module.exports = __webpack_public_path__ + "static/img/hnweR22.56dffd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/internationalBrand/hnweR22.jpg
// module id = 7Cyy
// module chunks = 1